import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    
    // Check for parameters
    const params = route.queryParams;
    // If params contain and address, latitude & longitude, redirect to packages with parameters
    if (params.address && params.latitude && params.longitude) {
      this.router.navigate(['/packages'], { 
        queryParams: params
       });
      return false;
    } 
    else 
      {
        // Redirect to home if params are empty
        this.router.navigate(['/home']);
        return false;
      }

  }
}
